<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10"><path d="M10 1.42 6.42 5 10 8.58 8.58 10 5 6.42 1.42 10 0 8.58 3.58 5 0 1.42 1.42 0 5 3.58 8.58 0z" class="tw-fill-namaGray dark:tw-fill-white"/></svg>
</template>
